import { render, staticRenderFns } from "./AAsignarCobradorFechas.vue?vue&type=template&id=208c3795"
import script from "./AAsignarCobradorFechas.vue?vue&type=script&lang=js"
export * from "./AAsignarCobradorFechas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports